import React from "react";
import css from "../../css/agents/active-filters.module.css";
import PropTypes from "prop-types";

const ActiveFilter = (props) => {
    const { name, label, value, onDelete } = props;
    const filterValues =
        name === "name" || name === "location"
            ? [value]
            : value.split(",");

    return (
        <>
            {filterValues.map((filterValue, index) => (
                <div className={css.activeFilter} key={index}>
                    <span className={css.label}>{label}</span>
                    <span className={css.value}>{filterValue}</span>
                    {onDelete && (
                        <button
                            className={css.button}
                            onClick={() => onDelete(name, filterValue)}
                            aria-label="Close"
                        >
                            <div className={css.closeIcon} />
                        </button>
                    )}
                </div>
            ))}
        </>
    );
};

ActiveFilter.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
};

export default ActiveFilter;
